import React from "react";
import { Table as MantineTable } from "@mantine/core";
import styled, { css } from "styled-components";
export const PINNED_CELL_CLASS_NAME = "table-pinned-cell";
export const PINNED_CELL_STRIPED_CLASS_NAME = "table-pinned-cell-striped";
export const getPinnedCellClassName = (isPinned, isStripedRow) => {
  if (!isPinned) {
    return void 0;
  }
  return isStripedRow ? PINNED_CELL_STRIPED_CLASS_NAME : PINNED_CELL_CLASS_NAME;
};
const StyledTable = styled(MantineTable)(
  ({ theme, $striped, $hover, $condensed, $bordered }) => css`
    --table-border-color: ${theme.colors.table.row.divider};
    font-size: inherit;
    line-height: inherit;

    ${$bordered && css`
      border: 1px solid ${theme.colors.table.row.divider};
    `}

    & th,
    & td {
      padding: ${$condensed ? "5px" : "8px"};
      vertical-align: top;
      border-top: 1px solid ${theme.colors.table.row.divider};
      ${$bordered && css`
        border: 1px solid ${theme.colors.table.row.divider};
      `}
    }

    & thead > tr > th {
      background-color: ${theme.colors.table.head.background};
      white-space: nowrap;
      vertical-align: bottom;
      border-top: none;
      border-bottom: 1px solid ${theme.colors.table.row.divider};
    }

    & tbody > tr {
      background-color: ${theme.colors.global.contentBackground};
      transition: background-color 150ms ease-in-out;
    }

    ${$striped && css`
      & tbody:only-of-type > tr:nth-of-type(odd) {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }

      & tbody:not(:only-of-type):nth-of-type(odd) > tr {
        background-color: ${theme.colors.table.row.background};
      }

      & tbody:not(:only-of-type):nth-of-type(even) > tr {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }
    `}

    ${$hover && css`
      & tbody > tr:hover {
        background-color: ${theme.colors.table.row.backgroundHover};
      }
    `}

    & thead > tr > th.${PINNED_CELL_CLASS_NAME} {
      background-color: ${theme.utils.flattenColorStack([
    theme.colors.global.contentBackground,
    theme.colors.table.head.background
  ])};
    }

    & tbody > tr > .${PINNED_CELL_CLASS_NAME}, & tfoot > tr > .${PINNED_CELL_CLASS_NAME} {
      background-color: ${theme.utils.flattenColorStack([
    theme.colors.global.contentBackground,
    theme.colors.table.row.background
  ])};
    }

    & tbody > tr > .${PINNED_CELL_STRIPED_CLASS_NAME} {
      background-color: ${theme.utils.flattenColorStack([
    theme.colors.global.contentBackground,
    theme.colors.table.row.backgroundStriped
  ])};
    }

    @media print {
      & thead > tr > th {
        white-space: break-spaces;
        word-break: break-all;
      }
    }
  `
);
const Table = ({
  children = void 0,
  className = void 0,
  "data-testid": dataTestId = void 0,
  striped = void 0,
  hover = void 0,
  condensed = void 0,
  bordered = void 0,
  responsive = void 0
}) => {
  const table = /* @__PURE__ */ React.createElement(
    StyledTable,
    {
      className,
      "data-testid": dataTestId,
      $striped: striped,
      $hover: hover,
      $condensed: condensed,
      $bordered: bordered
    },
    children
  );
  if (responsive) {
    return /* @__PURE__ */ React.createElement("div", { style: { overflowX: "auto" } }, table);
  }
  return table;
};
export default Table;
